const Icon = ({ name, ...props }) => 
	<div translate="no" className="icon" {...props}>
		{name}
	</div>

export default Icon